/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  query MyQuery {
    DevInfoForAdmin {
      companyEmail
      companyName
      phone
      reason
      isAccepted
      message
      status
      createdAt
      id
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
